export enum CardReaderStatus {
  ONLINE = "online",
  OFFLINE = "offline",
}

export interface ICardReader {
  id: string;
  /** The custom label given to the reader for easier identification. */
  label: string;
  /** The location ID of the reader */
  location: string | null;
  /** Whether the reader is online or offline.
   * This does not necessarily reflect the network connectivity of the reader. */
  status: CardReaderStatus | null;
}

export interface ICardReaderReady { ready: true }
export interface ICardReaderNotReady { ready: false, reason: "BUSY" | "DELETED", detail?: string }
export type TCardReaderReadiness = ICardReaderReady | ICardReaderNotReady;